<template>
    <service-card
        ref="serviceCard"
        :service-tips="serviceTips"
        :service="service"
        icon="mdi-car"
        :order="order"
        :variants-available="variantsAvailable"
        @show-info="showInfo"
        @modify-service="$emit('modify-service', $event)"
        @minimized-change="minimizedChange"
    >
        <template v-slot:checkbox>
            <slot name="checkbox" />
        </template>
        <template v-slot:icons>
            <slot name="icons" />
        </template>
        <template v-slot:orderInfo>
            <order-info-base
                :service="service"
                :service-check-in="serviceCheckIn"
                :service-check-out="serviceCheckOut"
                :service-image="mainImage"
                :is-package="isPackage"
                :tariff-name="service.serviceDetails[0].tariffName"
                :service-label="serviceDetails.planName"
                :order="order"
                :order-end-date="orderEndDate"
                @cancel-service="$emit('cancel-service', $event)"
                @modify-service="$emit('modify-service', $event)"
            >
                <div class="order-info-base-info">
                    <span class="order-info-base-info__icon">
                        <v-icon start size="x-small">mdi-city</v-icon>
                        <span class="text-body-2">{{ $t('countries') }}</span>
                    </span>
                    <span class="order-info-base-info__text"> {{ serviceDetails.zoneName }} </span>
                </div>
            </order-info-base>
        </template>
        <template v-slot:serviceInfo>
            <service-info-dialog v-model="modal" :service="service" :info="info" :image="mainImage">
                <template v-if="info" v-slot:serviceInfo>
                    <div class="mb-1 font-weight-medium text-body-1 text-grey">
                        {{ serviceDetails.planName }}
                    </div>
                    <div class="mb-1">
                        {{
                            `${$t('duration')}: ${serviceDetails.durationDays} ${$t(
                                'day',
                                serviceDetails.durationDays
                            )}`
                        }}
                    </div>
                </template>
            </service-info-dialog>
        </template>
    </service-card>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import ServiceInfoDialog from '~/components/account/orderServices/ServiceInfoDialog.vue'
    import ServiceCard from '~src/components/account/orderServices/serviceCard.src'
    import OrderInfoBase from '~src/components/account/orderServices/orderInfoBase.src'
    import {ServiceBase} from '@/components/account/orderServices/ServiceBase.vue'

    @Component({
        components: {
            ServiceCard,
            OrderInfoBase,
            ServiceInfoDialog,
        },
    })
    export class InsuranceService extends ServiceBase {
        @Prop({required: true}) service
        @Prop({default: false}) isPackage

        modal = false

        showInfo() {
            if (!this.infoLoadingFinished) {
                this.loadProductInfo()
            }

            this.modal = true
        }

        get mainImage() {
            return ''
        }

        get info() {
            return {}
        }

        get serviceCheckIn() {
            const date = this.$filters.dateFormat(this.service.startDateTime)
            return `<span>${date}</span>`
        }

        get serviceCheckOut() {
            const date = this.$filters.dateFormat(this.service.endDateTime)
            return `<span>${date}</span>`
        }

        get serviceDetails() {
            return this.service.serviceDetails[0]
        }

        get isTO1() {
            return authStore.isTO1
        }
    }

    export default InsuranceService
</script>
